// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3XG2N","rootMobile":"styles_rootMobile__rKEuu"};